import React, { useEffect, useState } from "react";
import { Text, View, TouchableOpacity } from "react-native";
import { useNavigation } from "@react-navigation/core";
import { styles } from "./styles";
import NumberInput from "../../components/NumberInput";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { FormattedMessage } from "react-intl";
import HeaderTabs from "../../components/HeaderTabs";

const DepositMethod = () => {
  const navigation = useNavigation();

  const [amount, setAmount] = useState(50);

  useEffect(() => {
    if (amount < 50) {
      setAmount(50);
    }
  }, [amount]);

  async function onSubmit() {
    await AsyncStorage.setItem("depositAmount", `${amount}`);
    navigation.navigate("DepositPaymentMethod");
  }

  return (
    <View>
      <HeaderTabs
        title={<FormattedMessage id="depositGpxAmount.titleValor" />}
        subtitle={
          <Text style={{ fontWeight: "500", marginBottom: 12 }}>
            <FormattedMessage id="depositGpxAmount.informeValorDesejado" />
          </Text>
        }
      />

      <View style={styles.container}>
        <View style={styles.inputContainer}>
          <NumberInput value={amount} onChange={setAmount} minValue={50} />
        </View>
        <View>
          <Text style={{ color: "#000", fontSize: 12 }}>
            <Text style={{ fontWeight: "bold" }}>
              <FormattedMessage id="depositgpxamount.TaxaLabel" />
            </Text>
            {"\n"}
            {/* <FormattedMessage id= "depositgpxamount.asTaxasDeposito"/>
          {"\n"} */}
            <FormattedMessage id="depositgpxamount.0.99Pix" />
            {"\n"}
            <FormattedMessage id="depositgpxamount.3R$Boleto" />
            {"\n"}
            {"\n"}
            <Text style={{ fontWeight: "bold" }}>
              <FormattedMessage id="depositgpxamount.InformacoesLabel" />
            </Text>
            {"\n"}
            <FormattedMessage id="depositgpxamount.asTaxas" />
            {"\n"}
            <FormattedMessage id="depositgpxamount.oValorMinimo" />
          </Text>
        </View>

        <View style={styles.btnContainer}>
          <TouchableOpacity
            onPress={() => navigation.goBack()}
            style={styles.goBackBtn}
          >
            <Text style={styles.goBackBtnText}>
              <FormattedMessage id="goBackButton.labelVoltar" />
            </Text>
          </TouchableOpacity>

          <TouchableOpacity onPress={onSubmit} style={styles.actionButton}>
            <Text style={styles.actionButtonText}>
              <FormattedMessage id="depositgpxamount.escolherPagamento" />
            </Text>
          </TouchableOpacity>
        </View>
      </View>
    </View>
  );
};

export default DepositMethod;
